import styled, { StyledComponent } from 'styled-components';
import { Theme } from '@inplayer-org/inplayer-ui';

const BoxItemDefaultGrid: StyledComponent<'div', Theme> = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(14%, 1fr));
  grid-auto-rows: 25vh;
  column-gap: 1.5rem;
  row-gap: 12px;
  margin: 0 auto;
  width: 100%;
`;

export default BoxItemDefaultGrid;
